import styled from 'styled-components';
import { Box } from '@mui/material';
import { Avatar, IconGraphy, Typography, colors } from '@leapeasy/ui-kit';

export const AvatarItem = ({ img_sec, label, value, isLastItem = false }) => {
  return (
    <Container>
      <Avatar
        size="x-large"
        iconImage={img_sec ? <img src={img_sec} /> : <IconGraphy icon="Users.User" />}
      />
      <Box flexGrow={1} fontWeight={500}>
        <Box width="fit-content" margin="auto" whiteSpace="nowrap">
          <Typography variant="body3" style={{ color: colors.black[600], marginBottom: 8 }}>
            {label}
          </Typography>
          <Typography variant="body3" style={{ color: colors.purple[900] }}>
            {value}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-grow: 1;
  font-weight: 500;
  flex-wrap: nowrap;
  border-right: 1px solid ${colors.purple[200]};
  padding: 0 10px;
`;
